import { DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import React from 'react';
import { ExperimentSpecs } from '../../../constants';
import { DeclaredExperimentsProvider } from '../../../hooks/declaredExperiments';
import { useIsSiteLevelGateOptimized } from '../../../hooks/useIsSiteLevelGateOptimized';
import { usePerceptionEnabled, usePerceptionPricing } from '../../../pricingPerception';
import { HarmonyThemeProvider } from '@wix/core-domain-search';
import { isBmHarmonyThemeEnabled } from '../../../utils/harmonyTheme';
import { SearchGateHomeContent } from '../../SearchGateHome';
import { SiteLevelGateHomeOptimizedContent } from '../../SiteLevelGateOptimized';
export const SiteLevelGateHomePage = _ref => {
  let {
    handlers,
    externalViewer
  } = _ref;
  const isOptimized = useIsSiteLevelGateOptimized();
  const {
    Layouts: perceptionLayouts
  } = usePerceptionPricing('businessManagerGate');
  // Declared at the page, so it covers both variants and every priced section inside them.
  const experimentIds = usePerceptionEnabled() ? [ExperimentSpecs.PricingPerceptionFirstYear] : [];
  const isHarmonyTheme = isBmHarmonyThemeEnabled();
  return /*#__PURE__*/React.createElement(DeclaredExperimentsProvider, {
    ids: experimentIds
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: ['alreadyAssignedToThisSite', 'alreadyAssigned', 'floatingDomain'],
      handlers,
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      }
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, {
    Layouts: {
      customConfiguration: perceptionLayouts ?? {}
    }
  }, /*#__PURE__*/React.createElement(HarmonyThemeProvider, {
    enabled: isHarmonyTheme
  }, isOptimized ? /*#__PURE__*/React.createElement(SiteLevelGateHomeOptimizedContent, {
    perception: Boolean(perceptionLayouts)
  }) : /*#__PURE__*/React.createElement(SearchGateHomeContent, {
    perception: Boolean(perceptionLayouts)
  })))));
};
//# sourceMappingURL=SiteLevelGateHomePage.js.map